import { ActionCuepoint } from "services/graphql";

interface UseActionCuepointsProps {
  actionCuepoints?: ActionCuepoint[];
  currentTime: number;
}

export function useActionCuepoints({
  actionCuepoints = [],
  currentTime,
}: UseActionCuepointsProps) {
  const actionCuepoint = actionCuepoints.find(
    cuepoint =>
      currentTime >= cuepoint.startsAtTimeSec &&
      currentTime <= cuepoint.endsAtTimeSec
  );

  return {
    actionCuepoint,
  };
}
